import {
  GET_LESSON,
  GET_LESSON_SUCCESS,
  GET_LESSON_CLEAN,
  GET_LESSON_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  lesson: undefined,
}

const LessonGet = (state = initialState, action) => {
  switch (action.type) {
    case GET_LESSON:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_LESSON_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        lesson: action.payload.lesson,
      }
      break
    case GET_LESSON_CLEAN:
      state = initialState
      break
    case GET_LESSON_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default LessonGet
